import React, { useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useCookies } from 'react-cookie';
import { useHistory, Link } from "react-router-dom";

function WarZone(props) {
  	let history = useHistory();
	const [cookies] = useCookies(['user']);
	const user_id = cookies.user_id;
	const token = cookies.token;
  	const { state } = props.location;
    console.log(state);
	const [opponentDetail] = useState(state[0]);
	const [kdDetail] = useState(state[1]);
	const [goTow, setGoToWar] = useState('');
	const [progressBar, setProgressBar] = useState({"step0":{"class":"is-active","span":<span>(0/3)</span>},"step1":{"class":"","span":''},"step2":{"class":"","span":''},"step3":{"class":"","span":''}});
	const [warResult, setWarResult] = useState('');

	useEffect(() => {
		if(kdDetail.monthly_war_initiated === 0){
			setProgressBar({"step0":{"class":"is-active","span":<span>(0/3)</span>},"step1":{"class":"","span":''},"step2":{"class":"","span":''},"step3":{"class":"","span":''}});
		} else if(kdDetail.monthly_war_initiated === 1){
			setProgressBar({"step0":{"class":"is-complete","span":''},"step1":{"class":"is-active","span":<span>(1/3)</span>},"step2":{"class":"","span":''},"step3":{"class":"","span":''}});
		} else if(kdDetail.monthly_war_initiated === 2){
			setProgressBar({"step0":{"class":"is-complete","span":''},"step1":{"class":"is-complete","span":''},"step2":{"class":"is-active","span":<span>(2/3)</span>},"step3":{"class":"","span":''}});
		} else {
			setProgressBar({"step0":{"class":"is-complete","span":''},"step1":{"class":"is-complete","span":''},"step2":{"class":"is-complete","span":''},"step3":{"class":"is-active","span":<span>(3/3)</span>}});
		}
		var gtw = "";
		if(kdDetail.monthly_war_initiated <= 3){
			var gtw = <a className="shadow btn btn-primary d-flex mx-auto" onClick={() => goToWar()} data-toggle="modal" data-target="#bottom_modal" >Go to War</a>
		}
		setGoToWar(gtw);
	}, []);

	async function goToWar(){
		let oppenentKdId = opponentDetail.k_id;
		let selfKdId = kdDetail.kd_id;
		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json','token':token,'userId':user_id  },
			body: JSON.stringify({dist_user_id:user_id,opponent_k_id:oppenentKdId,self_k_id:selfKdId}),
		};

		console.log(requestOptions);
		const response	 = await fetch(process.env.REACT_APP_BKB_URL_DOMAIN + 'bkb-initiate-war', requestOptions);
		const data = await response.json();
		if(data.status === "success"){
			if(data.result === "won"){
				var html = <div className="modal-body p-0">
					<img src={require("./../images/congratulation.png").default} className="d-block mx-auto" alt="c"/>
					<img src={require("./../images/congo-profile.png").default} className="d-block mx-auto" alt="cr"/>
					<p className="text-center mb-1">{data.message}<span>{data.bold_message}</span></p>
					<div className="mx-auto total-wealth mb-2">
				   		<p className="text-center mb-0">Total kingdom wealth <span>{parseFloat(data.new_wealth).toFixed(2)}</span></p>
					</div>
					<button className="btn btn-primary d-block mx-auto mb-2" data-dismiss="modal" aria-label="Close">OK, got it</button>
			   </div>;
			} else {
				var html = <div className="modal-body p-0">
					<img src={require("./../images/lose.png").default} className="d-block mx-auto" alt=""/>
					<img src={require("./../images/lose-profile.png").default} className="d-block mx-auto" alt=""/>
					<p className="text-center mb-1"><span>{data.bold_message}</span>{data.message}</p>
					<div className="mx-auto total-wealth mb-2">
					<p className="text-center mb-0">Total kingdom wealth <span>{parseFloat(data.new_wealth).toFixed(2)}</span></p>
					</div>
					<button className="btn btn-primary d-block mx-auto mb-2" data-dismiss="modal" aria-label="Close">OK, got it</button>
			   </div>;
			}
			let warIni = kdDetail.monthly_war_initiated + 1;
			if(warIni === 0){
				setProgressBar({"step0":{"class":"is-active","span":<span>(0/3)</span>},"step1":{"class":"","span":''},"step2":{"class":"","span":''},"step3":{"class":"","span":''}});
			} else if(warIni === 1){
				setProgressBar({"step0":{"class":"is-complete","span":''},"step1":{"class":"is-active","span":<span>(1/3)</span>},"step2":{"class":"","span":''},"step3":{"class":"","span":''}});
			} else if(warIni === 2){
				setProgressBar({"step0":{"class":"is-complete","span":''},"step1":{"class":"is-complete","span":''},"step2":{"class":"is-active","span":<span>(2/3)</span>},"step3":{"class":"","span":''}});
			} else {
				setProgressBar({"step0":{"class":"is-complete","span":''},"step1":{"class":"is-complete","span":''},"step2":{"class":"is-complete","span":''},"step3":{"class":"is-active","span":<span>(3/3)</span>}});
			}
		} else {
			var html = <div className="modal-body p-0">
					<p className="text-center mb-1"><span>{data.message}</span></p>
					<button className="btn btn-primary d-block mx-auto mb-2" data-dismiss="modal" aria-label="Close">OK, got it</button>
				</div>;
		}
		setWarResult(html);
	}
	
    return (
<>
	<Helmet link={
		[{"rel": "stylesheet", "href": 'css/warzone.css'}]
	}/>
    <div className="row no-gutters">
      	<div className="application bg-grey">

        	<div className="bg-gradient1 ">
		        <div className="appHeader bg-transparent text-light position-relative">
         			<div className="left">
              			<a className="headerButton goBack" onClick={() => history.goBack()}>
                			<img src={require("./../images/back.png").default} alt="back" className="img-fluid" />
              			</a>
          			</div>

					<div className="right">
						<Link to="/faq" className="headerButton">
							<img src={require("./../images/faq1.png").default} alt="faq" className="img-fluid" />
						</Link>
					</div>
        		</div>
        
        		<div className="section mt-2 kingdom">	
					<div className="kingdom-left">
						<h2>War Zone</h2>
					</div>
				</div>
    		</div>

        	<div className="section warzone">
            	<div className="row mx-auto">
                	<p>You have chosen to go to war with kingdom <br/>{opponentDetail.name}. Click on the button below to proceed.</p>
            	</div>
				<div className="row mx-auto">
					<img src={require("./../images/warzone-icon.png").default} alt="faq" className="img-fluid ml-auto d-block" data-toggle="modal" data-target="#bottom_modal1" />
				</div>
            	<div className="row mx-auto mt-2">
                	<div className="card" style = {{
						backgroundImage: `linear-gradient(0deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3)) , url(${kdDetail.kd_image}) `,
						backgroundSize: `100% 100%`,
						borderBottomLeftRadius: `8px`,
						borderBottomRightRadius: `8px`,
						display: `block`,
					}}>
						<div className="overlay"></div>
						<div className="card-body">
							<div className="profile-icon">
								<div className="d-inline-block"></div>
								<div  className="kv" ></div>
								<p className="d-inline-block text-center">Kingdom {opponentDetail.name}</p>
							</div>
							<div className="col-7 mx-auto mt-5">
								{goTow}
							{/* { kdDetail.monthly_war_initiated >= 3 && (
								<a className="shadow btn btn-primary d-flex mx-auto" onClick={() => goToWar()} data-toggle="modal" data-target="#bottom_modal" >Go to War</a>
							)} */}
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="section mt-3 footer">
				<div className="row mx-auto">
					<div className="card w-100 h-117">
						<div className="card-body">
							<div className="d-flex">
								<p className="d-inline-block">War</p>
							<Link to={{
									pathname:"/war-history",
									state: [kdDetail]
								}}  className="d-inline-block ml-auto">
								View History
								</Link>
							</div>
							<div className="mt-2">
								<ol className="progress progress--large">
									<li className={progressBar.step0.class} data-step="0">
										{progressBar.step0.span}
									</li>
									<li className={progressBar.step1.class} data-step="1">
										{progressBar.step1.span}
									</li>
									<li className={progressBar.step2.class} data-step="2">
										{progressBar.step2.span}
									</li>
									<li data-step="3" className={progressBar.step3.class}>
										{progressBar.step3.span}
									</li>
								</ol>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div className="bg"></div>
	</div>

	<div className="modal modal-bottom fade" id="bottom_modal" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal">
		<div className="modal-dialog" role="document">
			<div className="modal-content">
				<div className="modal-header border-bottom-0 pb-0">
					<button type="button" className="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				{warResult}
			</div>
		</div>
	</div>

	<div className="modal modal-bottom fade" id="bottom_modal1" tabIndex="-1" role="dialog" aria-labelledby="bottom_modal1">
		<div className="modal-dialog" role="document">
			<div className="modal-content">
				<div className="modal-body">
					<div className="row mx-auto">
						<p className="note">NOTE:</p>
					</div>
					<p>You can only go to war Three ( 3 ) times at<br/> the end of every month.</p>
					<button className="btn btn-primary d-block mx-auto px-5 mb-2" data-dismiss="modal" aria-label="Close">OK, got it</button>
				</div>
			</div>
		</div>
	</div>

</>
    );
}

export default WarZone;
